import ScoreFixture from "./ScoreFixture";
export default ScoreFixture;
